export const SITE = {
  name: "Deny's Burger",
  tagline: "Burger & Fries",
  phoneDisplay: "+90 532 322 21 30",
  phoneUrl: "tel:+905323222130",
  instagramUrl: "https://instagram.com/denysburger",
  whatsappUrl: "https://wa.me/905323222130",
};

export const PLATFORMS = [
  {
    key: "yemeksepeti_url",
    name: "Yemeksepeti",
    logo: "https://upload.wikimedia.org/wikipedia/commons/d/de/Yemeksepeti_logo.svg",
  },
  {
    key: "getir_url",
    name: "Getir Yemek",
    logo: "https://upload.wikimedia.org/wikipedia/commons/3/38/Getir_wordmark.svg",
  },
  {
    key: "trendyol_url",
    name: "Trendyol Yemek",
    logo: "https://upload.wikimedia.org/wikipedia/commons/c/c7/Trendyol_logo.svg",
  },
  {
    key: "migros_url",
    name: "Migros Yemek",
    logo: "/assets/migros-yemek-logo.png",
  },
];

const IMG_BASE =
  "https://customer-assets-agu9un31.emergentagent.net/job_ab1da398-7738-4355-ae01-88c4446a367e/artifacts";
const MENU_IMG_BASE =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_burger-simple/artifacts";

export const IMAGES = {
  hero: `${IMG_BASE}/12wexa1p_afi%C5%9F%204.jpeg`,
  whyUs: `${IMG_BASE}/12wexa1p_afi%C5%9F%204.jpeg`,
  fries: `${IMG_BASE}/4ek3i7gj_afi%C5%9F%201.jpeg`,
};

export const BRANCHES = [
  {
    code: "REMJUK",
    name: "Deny's Burger & Fries",
    address: "3038. Sokak, Güzelyalı Mah. No:2A, Atakum / Samsun",
    hours: "Her gün 11:00 - 22:00",
  },
];


export const MENU_ITEMS = [
  {
    id: "cheeseburger",
    name: "Cheeseburger",
    desc: "Erimiş cheddar, özel sos, taze yeşillikler, karamelize soğan, domates turşu ve %100 dana köfte.",
    img: `${MENU_IMG_BASE}/a8fmzrv8_cheeseburger%20men%C3%BC.jpeg`,
  },
  {
    id: "hamburger",
    name: "Hamburger",
    desc: "Özel sos, taze yeşillikler, karamelize soğan, domates turşu ve %100 dana köfte.",
    img: `${MENU_IMG_BASE}/j9esaha3_hamburger%20men%C3%BC.jpeg`,
  },
  {
    id: "doubleburger",
    name: "Doubleburger",
    desc: "İki kat köfte, iki kat erimiş cheddar, özel sos, taze yeşillikler, karamelize soğan, domates turşu ve %100 dana köfte — maksimum lezzet.",
    img: `${MENU_IMG_BASE}/4vgsm2hj_doubleburger%20men%C3%BC.jpeg`,
  },
  {
    id: "marulburger",
    name: "Marulburger",
    desc: "Ekmeksiz lezzet: bol marul sarmasında erimiş cheddar, domates, özel sos ve %100 dana köfte.",
    img: `${MENU_IMG_BASE}/qhy2vt56_marul%20burger.jpeg`,
  },
  {
    id: "cocuk-menusu",
    name: "Çocuk Menüsü",
    desc: "Klasik lezzet: %100 dana köfte, turşu ve özel sos.",
    img: `${MENU_IMG_BASE}/1jt16ack_%C3%A7ocuk%20men%C3%BCs%C3%BC.jpeg`,
  },
  {
    id: "patates",
    name: "Efsane Taze Patates",
    desc: "Taze kesilmiş, çıtır çıtır, dışı kıtır içi yumuşak patates kızartması.",
    img: `${MENU_IMG_BASE}/00zewzm9_patates%20k%C4%B1zartmas%C4%B1%20tek.jpeg`,
  },
];
